/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CourtCasesService {
    /**
     * List all court cases
     * Get a paginated list of court cases for the authenticated user
     * @param clientId Filter by client ID
     * @param caseStatus Filter by case status ID
     * @param priority Filter by priority (High, Medium, Low)
     * @param search Search in case number, party name, or filing number
     * @param perPage Items per page
     * @returns any List of court cases
     * @throws ApiError
     */
    public static a2E36D76750F793D8Af62F1Dda47A82E(
        clientId?: number,
        caseStatus?: number,
        priority?: 'High' | 'Medium' | 'Low',
        search?: string,
        perPage: number = 15,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/court-cases',
            query: {
                'client_id': clientId,
                'case_status': caseStatus,
                'priority': priority,
                'search': search,
                'per_page': perPage,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create a new court case
     * Create a new court case for the authenticated user
     * @param requestBody
     * @returns any Court case created successfully
     * @throws ApiError
     */
    public static dbaf97C4E9Bd8Cce8Bd5E8097A3D295F(
        requestBody: {
            advo_client_id: number;
            department_id?: number | null;
            client_position: 'Respondent' | 'Petitioner';
            party_name: string;
            party_lawyer: string;
            case_number?: string | null;
            case_types: number;
            case_sub_type?: number | null;
            case_status: number;
            act?: string | null;
            priority: 'High' | 'Medium' | 'Low';
            court_no: string;
            court_type: number;
            court: number;
            judge_type: number;
            judge_name?: string | null;
            filing_number: string;
            filing_date: string;
            registration_number: string;
            registration_date: string;
            remark?: string | null;
            description?: string | null;
            is_nb: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/court-cases',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get a specific court case
     * Retrieve details of a specific court case
     * @param id Court case ID
     * @returns any Court case details
     * @throws ApiError
     */
    public static a8444F144433Ad212Ca9E1Dceced96E(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/court-cases/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Court case not found`,
            },
        });
    }
    /**
     * Update a court case
     * Update an existing court case
     * @param id Court case ID
     * @param requestBody
     * @returns any Court case updated successfully
     * @throws ApiError
     */
    public static afa5674Bb49Ce35C856Cd28A8B8Eed6(
        id: number,
        requestBody: {
            advo_client_id?: number;
            case_status?: number;
            priority?: 'High' | 'Medium' | 'Low';
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/court-cases/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `Court case not found`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Delete a court case
     * Delete a court case
     * @param id Court case ID
     * @returns any Court case deleted successfully
     * @throws ApiError
     */
    public static b04Ffdb8D512E02705C1Fa5Fd87913Ed(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/court-cases/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Court case not found`,
            },
        });
    }
}
